import { useCompanyId } from 'application/providers/AccountProvider';
import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

import { useBillingCompanyBillingInfoQuery } from 'domain/api/graphql/generated';
import { FetchPolicyKeys } from 'domain/api/graphql/types';

import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';
import TimezoneUtils from '@zvuk-b2b/react-uikit/toolkit/TimezoneUtils';

import { UseNextDateViewModel } from './types';

const useNextDateViewModel = (): UseNextDateViewModel | null => {
  const companyId = useCompanyId();

  const { data: billingInfoData, loading: billingInfoLoading } = useBillingCompanyBillingInfoQuery({
    variables: {
      companyId,
    },
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  if (!billingInfoData || !billingInfoData.result || billingInfoLoading) {
    return null;
  }

  const { nextBillingDate, renewableLicenses, hasTrialLicenses, isWaitPaymentLicense, isGraceLicense } =
    billingInfoData.result;

  const licensesCount = TEXTS.TOTAL_PRICE_BLOCK_FIRST_DEBITING_POINT_COUNT_TEXT(renewableLicenses.length);

  const dateWithoutTimezoneOffset = TimezoneUtils.getDateWithoutTimezoneOffset(nextBillingDate);
  const formatNextBillingDate = DateUtils.getFormatDateFrom(dateWithoutTimezoneOffset, 'dd MMMM yyyy');

  return {
    nextBillingDate,
    hasTrialLicenses,
    isWaitPaymentLicense: Boolean(isWaitPaymentLicense),
    isGraceLicense: Boolean(isGraceLicense),
    licensesCount,
    formatNextBillingDate,
  };
};

export default useNextDateViewModel;
